<template>
  <div>
    <!-- นำทาง -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title class="body-1">
        {{ use_language.menu_orders }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.refund_return_list }}
      </v-card-title>
    </v-card>

    <!-- ค้นหา -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-icon color="blue" size="24">fa-sliders-h</v-icon>
        <span class="ml-2">{{ use_language.search_data }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <!-- แถวที่ 1: วันที่สร้าง | เลขออเดอร์ -->
        <v-row class="align-center pb-1">
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.creation_date }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <div class="d-flex" style="gap: 8px;">
              <div style="flex: 1 1 0; min-width: 0;">
                <v-menu v-model="menuDateFrom" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="formatDateShort(filter.dateFrom)" :placeholder="use_language.start" prepend-inner-icon="mdi-calendar"
                      readonly clearable outlined dense hide-details v-bind="attrs" v-on="on" @click:clear="filter.dateFrom = null"></v-text-field>
                  </template>
                  <v-date-picker v-model="filter.dateFrom" no-title @input="menuDateFrom = false"></v-date-picker>
                </v-menu>
              </div>
              <div style="flex: 1 1 0; min-width: 0;">
                <v-menu v-model="menuDateTo" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="formatDateShort(filter.dateTo)" :placeholder="use_language.end" prepend-inner-icon="mdi-calendar"
                      readonly clearable outlined dense hide-details v-bind="attrs" v-on="on" @click:clear="filter.dateTo = null"></v-text-field>
                  </template>
                  <v-date-picker v-model="filter.dateTo" no-title @input="menuDateTo = false"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.order_number }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-text-field v-model="filter.orderNo" @keyup.enter="search()"
              :label="use_language.enter_comma_to_search_multiple"
              clearable outlined dense hide-details autocomplete="off"></v-text-field>
          </v-col>
        </v-row>

        <!-- แถวที่ 2: ช่องทาง | เลขอ้างอิงออเดอร์ -->
        <v-row class="align-center pb-1">
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.channel }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-select v-model="filter.referenceSourceID" :items="platformList" item-text="name" item-value="id"
              :placeholder="use_language.all_" clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.reference_order_number }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-text-field v-model="filter.orderSN" @keyup.enter="search()"
              :label="use_language.enter_comma_to_search_multiple"
              clearable outlined dense hide-details autocomplete="off"></v-text-field>
          </v-col>
        </v-row>

        <!-- แถวที่ 3: ประเภท | ตีกลับ -->
        <v-row class="align-center pb-1">
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.category }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-select v-model="filter.returnType" :items="returnTypeList" item-text="name" item-value="id"
              :placeholder="use_language.all_" clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.return_tracking_no }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-text-field v-model="filter.trackingNo" @keyup.enter="search()"
              :label="use_language.enter_comma_to_search_multiple"
              clearable outlined dense hide-details autocomplete="off"></v-text-field>
          </v-col>
        </v-row>

        <!-- แถวที่ 4: สถานะคำร้อง + ปุ่มค้นหา/ล้าง -->
        <v-row class="align-center pb-1">
          <v-col cols="12" sm="4" md="2" class="py-1 text-no-wrap grey--text text--darken-2">{{ use_language.request_status }} :</v-col>
          <v-col cols="12" sm="8" md="4" class="py-1">
            <v-select v-model="filter.returnStatusID" :items="returnStatusList" item-text="name" item-value="id"
              :placeholder="use_language.all_" clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2" class="d-none d-md-block"></v-col>
          <v-col cols="12" md="4" class="py-1 d-flex align-center justify-start">
            <v-btn :elevation="1" color="primary" class="pa-2" dark :loading="loading" @click="search()">
              <v-icon size="14" class="pr-1">fa-solid fa-magnifying-glass</v-icon>
              {{ use_language.search }}
            </v-btn>
            <v-btn outlined color="primary" class="pa-2 ml-2" @click="clearFilter()">
              <v-icon size="14" class="pr-1">mdi mdi-refresh</v-icon>
              {{ use_language.clear }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- แสดงจำนวน -->
    <v-row class="ma-0 align-center">
      <v-col cols="12" sm="6" class="pa-0">
        {{ use_language.all_ }} {{ resultCount }} {{ use_language.row }}
      </v-col>
      <v-col cols="12" sm="6" class="pa-0 d-flex justify-end">
        <v-btn color="success" outlined :loading="loadingExcel" :disabled="loadingExcel || resultCount === 0" @click="exportExcel()">
          <v-icon size="16" class="pr-1">mdi mdi-microsoft-excel</v-icon>
          {{ use_language.export_excel }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- แสดงตาราง -->
    <v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="take"
      disable-sort hide-default-footer class="packhai-border-table refund-table">
      <template v-slot:[`item.no`]="{ index }">
        {{ resultCount - ((page - 1) * take + index) }}
      </template>
      <template v-slot:[`item.orderNo`]="{ item }">
        <a v-if="item.orderMasterID" class="red--text" style="cursor: pointer" @click="openOrderById(item.orderMasterID)">PA{{ item.orderMasterID }}</a>
        <span v-else>-</span>
        <div v-if="item.orderSN" class="caption grey--text text--darken-1">{{ item.orderSN }}</div>
      </template>
      <template v-slot:[`item.platform`]="{ item }">
        <v-tooltip bottom v-if="channelImg(item.referenceSourceID)">
          <template v-slot:activator="{ on }">
            <v-img v-on="on" :src="channelImg(item.referenceSourceID)" :alt="item.platform"
                   contain width="28" height="28" class="mx-auto" />
          </template>
          <span class="text-capitalize">{{ item.platform || '-' }}</span>
        </v-tooltip>
        <span v-else class="text-capitalize">{{ item.platform || item.referenceSourceID || '-' }}</span>
      </template>
      <template v-slot:[`item.returnStatusName`]="{ item }">
        <span :class="statusTextClass(item.returnStatusID)">{{ item.returnStatusName || item.returnStatusID || '-' }}</span>
      </template>
      <template v-slot:[`item.logisticStatusName`]="{ item }">
        <span :class="logisticTextClass(item.logisticStatusID)">{{ item.logisticStatusName || '-' }}</span>
      </template>
      <template v-slot:[`item.eventReferenceID`]="{ item }">
        <a v-if="item.eventReferenceID" class="red--text" style="cursor: pointer" @click="openDetail(item)">{{ item.eventReferenceID }}</a>
        <span v-else>-</span>
      </template>
      <template v-slot:[`item.trackingNo`]="{ item }">
        {{ item.trackingNo || '-' }}
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        {{ formatDateTime(item.updated) }}
      </template>
    </v-data-table>

    <div class="text-center pt-4">
      <v-pagination v-model="page" :length="pageLength" total-visible="9" @input="changePage"></v-pagination>
    </div>

    <!-- ===== Detail dialog (ดึงสดจาก platform + ข้อมูลที่เหลือ) ===== -->
    <v-dialog v-model="detail.show" max-width="860" scrollable>
      <v-card>
        <v-card-title>
          <v-icon color="teal darken-1" class="mr-2">mdi mdi-keyboard-return</v-icon>
          {{ use_language.bounce_details }}
          <v-spacer />
          <v-btn icon @click="detail.show = false"><v-icon>mdi mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 72vh">
          <!-- ข้อมูลจากระบบ -->
          <v-row class="pt-0">
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.order_number }} :</b> {{ detail.row.orderMasterID ? 'PA' + detail.row.orderMasterID : '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.reference_order_number }} :</b> {{ detail.row.orderSN || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.channel }} :</b> <span class="text-capitalize">{{ detail.row.platform || '-' }}</span></v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.category }} :</b> {{ detail.row.returnTypeName || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.request_number }} :</b> {{ detail.row.eventReferenceID || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.request_status }} :</b> {{ detail.row.returnStatusName || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.Return_shipment_status }} :</b> {{ detail.row.logisticStatusName || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.transport }} :</b> {{ detail.row.expressCompanyName || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.return_tracking_no }} :</b> {{ detail.row.trackingNo || '-' }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.creation_date }} :</b> {{ formatDateTime(detail.row.created) }}</v-col>
            <v-col cols="12" md="6" class="py-1"><b>{{ use_language.last_updated }} :</b> {{ formatDateTime(detail.row.updated) }}</v-col>
            <v-col cols="12" class="py-1"><b>{{ use_language.reason_system }} :</b> {{ detail.row.eventReason || '-' }}</v-col>
          </v-row>

          <v-divider class="my-3" />

          <!-- ดึงสดจากแพลตฟอร์ม -->
          <div class="fn-15 mb-2"><b>{{ use_language.live_platform_data }} ({{ use_language.reason }} / {{ use_language.picture }} / {{ use_language.video }})</b></div>
          <div v-if="detail.loading" class="text-center pa-6">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="pt-2 fn-13">{{ use_language.fetching_live_data }}...</div>
          </div>
          <div v-else-if="!detail.hasData" class="text-center pa-4 grey--text fn-14">{{ use_language.live_order_data_not_found }}</div>
          <div v-else>
            <div v-for="(r, ri) in detail.refunds" :key="ri">
              <v-divider v-if="ri > 0" class="my-4"></v-divider>
              <div class="fn-14 mb-1"><b>{{ use_language.ref_number }} :</b> {{ r.eventReferenceID || '-' }}</div>
              <div class="fn-14 mb-1"><b>{{ use_language.reason }} :</b> {{ r.reason || '-' }}</div>
              <div v-if="r.liveError" class="red--text fn-13 mb-2">{{ use_language.fetch_live_image }} error: {{ r.errorMessage }}</div>
              <div v-if="r.images && r.images.length" class="mb-2">
                <b class="fn-13">{{ use_language.attached_image }} : {{ r.images.length }} {{ use_language.picture }}</b>
                <div class="d-flex flex-wrap pt-1">
                  <img v-for="(img, ii) in r.images" :key="'img'+ii" :src="img"
                    class="ma-1 rounded" style="cursor: pointer; border: 1px solid #ddd; height: 180px; width: auto; object-fit: contain"
                    @click="openPhoto(img)" />
                </div>
              </div>
              <div v-if="r.videos && r.videos.length" class="mb-1">
                <b class="fn-13">{{ use_language.video }} : {{ r.videos.length }}</b>
                <div class="d-flex flex-wrap pt-1">
                  <video v-for="(vid, vi) in r.videos" :key="'vid'+vi" :src="vid" controls width="180"
                    class="ma-1 rounded" style="border: 1px solid #ddd"></video>
                </div>
              </div>
              <div v-if="(!r.images || !r.images.length) && (!r.videos || !r.videos.length)" class="grey--text fn-13">{{ use_language.no_image_video }}</div>
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <!-- <v-btn v-if="detail.row.orderMasterID" text color="primary" @click="openOrderById(detail.row.orderMasterID)">
            <v-icon left>mdi mdi-open-in-new</v-icon> เปิดออเดอร์
          </v-btn> -->
          <v-spacer />
          <v-btn text @click="detail.show = false">{{ use_language.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { ecomService_dotnet } from "@/website/global";
import { get_languages } from "@/website/global_function";
import { utils, writeFileXLSX } from "xlsx";

export default {
  data() {
    return {
      use_language: {},
      header_token: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorization_token"),
      },
      loading: false,
      loadingExcel: false,
      items: [],
      resultCount: 0,
      page: 1,
      take: 20,
      menuDateFrom: false,
      menuDateTo: false,
      filter: {
        referenceSourceID: null,
        returnType: null,
        returnStatusID: null,
        orderNo: null,
        orderSN: null,
        trackingNo: null,
        dateFrom: null,
        dateTo: null,
      },
      detail: {
        show: false,
        loading: false,
        hasData: false,
        refunds: [],
        row: {},
      },
    };
  },
  computed: {
    pageLength() {
      return Math.ceil(this.resultCount / this.take) || 1;
    },
    platformList() {
      return [
        { id: 0, name: this.use_language.all_ },
        { id: 3, name: "Shopee" },
        { id: 4, name: "Lazada" },
        { id: 11, name: "Tiktok" },
      ];
    },
    returnTypeList() {
      return [
        { id: 0, name: this.use_language.all_ },
        { id: 1, name: this.use_language.refund_money },
        { id: 2, name: this.use_language.refund_and_return },
        { id: 3, name: this.use_language.change_product },
        { id: 4, name: this.use_language.exchange_product },
      ];
    },
    returnStatusList() {
      return [
        { id: 0, name: this.use_language.all_ },
        { id: 10, name: this.use_language.create_new },
        { id: 20, name: this.use_language.waiting_buyer_action },
        { id: 30, name: this.use_language.approve_return },
        { id: 40, name: this.use_language.waiting_buyer_return },
        { id: 50, name: this.use_language.approve_request },
        { id: 60, name: this.use_language.platform_review },
        { id: 70, name: this.use_language.reject_action },
        { id: 80, name: this.use_language.cancel },
        { id: 90, name: this.use_language.succeed },
      ];
    },
    headers() {
      return [
        { text: "No", value: "no", width: 60, align: "center", sortable: false },
        { text: this.use_language.order_number, value: "orderNo", width: 150, align: "center" },
        { text: this.use_language.request_number, value: "eventReferenceID", width: 170, align: "center" },
        { text: this.use_language.channel, value: "platform", width: 100, align: "center" },
        { text: this.use_language.category, value: "returnTypeName", width: 130, align: "center" },
        { text: this.use_language.request_status, value: "returnStatusName", width: 140, align: "center" },
        { text: this.use_language.Return_shipment_status, value: "logisticStatusName", width: 150, align: "center" },
        { text: this.use_language.return_tracking_no, value: "trackingNo", width: 150, align: "center" },
        { text: this.use_language.last_updated, value: "updated", width: 140, align: "center", sortable: false },
      ];
    },
  },
  async mounted() {
    await this.search();
  },
  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
  },
  methods: {
    get_languages,
    async search() {
      this.page = 1;
      await this.loadData();
    },
    async changePage() {
      await this.loadData();
    },
    async loadData() {
      this.loading = true;
      try {
        let body = {
          ShopID: parseInt(localStorage.getItem("shop_id")),
          ReferenceSourceID: this.filter.referenceSourceID || null,
          ReturnType: this.filter.returnType || null,
          ReturnStatusID: this.filter.returnStatusID || null,
          OrderNoList: this.splitMulti(this.filter.orderNo),
          OrderSNList: this.splitMulti(this.filter.orderSN),
          TrackingNoList: this.splitMulti(this.filter.trackingNo),
          DateFrom: this.filter.dateFrom || null,
          DateTo: this.filter.dateTo || null,
          Skip: (this.page - 1) * this.take,
          Take: this.take,
          IsNeedResultCount: true,
        };
        let res = await axios.post(ecomService_dotnet + "Order/search-refund-request", body, {
          headers: this.header_token,
        });
        this.items = res.data.list || res.data.List || [];
        this.resultCount = res.data.searchResultCount || res.data.SearchResultCount || 0;
      } catch (e) {
        this.items = [];
        this.resultCount = 0;
      } finally {
        this.loading = false;
      }
    },
    async openDetail(item) {
      this.detail.show = true;
      this.detail.loading = true;
      this.detail.hasData = false;
      this.detail.refunds = [];
      this.detail.row = item || {};
      if (!item || !item.orderMasterID) {
        this.detail.loading = false;
        return;
      }
      try {
        let res = await axios.get(
          ecomService_dotnet + "Order/get-refund-info?OrderMasterID=" + item.orderMasterID,
          { headers: this.header_token }
        );
        if (res.data && res.data.hasData) {
          this.detail.hasData = true;
          this.detail.refunds = res.data.refunds || [];
        }
      } catch (e) {
        this.detail.hasData = false;
      } finally {
        this.detail.loading = false;
      }
    },
    splitMulti(val) {
      if (val == null) return [];
      const s = Array.isArray(val) ? val.join(",") : String(val);
      return [...new Set(s.split(",").map(v => v.trim()).filter(v => v !== ""))];
    },
    async exportExcel() {
      if (this.loadingExcel) return;
      this.loadingExcel = true;
      try {
        // ดึงทุกแถวตาม filter ปัจจุบัน (วนทีละก้อน)
        let all = [];
        let skip = 0;
        const chunk = 200;
        let total = null;
        let hasMore = true;
        while (hasMore) {
          let body = {
            ShopID: parseInt(localStorage.getItem("shop_id")),
            ReferenceSourceID: this.filter.referenceSourceID || null,
            ReturnType: this.filter.returnType || null,
            ReturnStatusID: this.filter.returnStatusID || null,
            OrderNoList: this.splitMulti(this.filter.orderNo),
            OrderSNList: this.splitMulti(this.filter.orderSN),
            TrackingNoList: this.splitMulti(this.filter.trackingNo),
            DateFrom: this.filter.dateFrom || null,
            DateTo: this.filter.dateTo || null,
            Skip: skip,
            Take: chunk,
            IsNeedResultCount: total === null,
          };
          let res = await axios.post(ecomService_dotnet + "Order/search-refund-request", body, {
            headers: this.header_token,
          });
          let list = res.data.list || res.data.List || [];
          if (total === null) {
            total = res.data.searchResultCount || res.data.SearchResultCount || 0;
          }
          all.push(...list);
          skip += chunk;
          if (list.length < chunk || all.length >= total || total === 0) hasMore = false;
        }

        if (all.length === 0) {
          this.$swal({ type: "warning", title: this.use_language.error, text: this.use_language.data_not_found });
          return;
        }

        const header = [
          "No",
          this.use_language.order_number,
          this.use_language.reference_order_number,
          this.use_language.request_number,
          this.use_language.channel,
          this.use_language.category,
          this.use_language.request_status,
          this.use_language.Return_shipment_status,
          this.use_language.transport,
          this.use_language.return_tracking_no,
          this.use_language.creation_date,
          this.use_language.last_updated,
          this.use_language.reason_system,
        ];
        const rows = all.map((item, i) => [
          i + 1,
          item.orderMasterID ? "PA" + item.orderMasterID : "-",
          item.orderSN || "-",
          item.eventReferenceID || "-",
          item.platform || "-",
          item.returnTypeName || "-",
          item.returnStatusName || "-",
          item.logisticStatusName || "-",
          item.expressCompanyName || "-",
          item.trackingNo || "-",
          this.formatDateTime(item.created),
          this.formatDateTime(item.updated),
          item.eventReason || "-",
        ]);

        const ws = utils.aoa_to_sheet([header, ...rows]);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "refund");
        const d = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        const dateStr = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
        writeFileXLSX(wb, this.use_language.refund_return_list + "_" + dateStr + ".xlsx");
      } catch (e) {
        this.$swal({ type: "error", title: this.use_language.error, text: this.use_language.cannot_proceed_try_again });
      } finally {
        this.loadingExcel = false;
      }
    },
    openOrderById(orderMasterID) {
      window.open("order-detail?id=" + orderMasterID, "_blank");
    },
    openPhoto(url) {
      window.open(url);
    },
    clearFilter() {
      this.filter = {
        referenceSourceID: null,
        returnType: null,
        returnStatusID: null,
        orderNo: null,
        orderSN: null,
        trackingNo: null,
        dateFrom: null,
        dateTo: null,
      };
      this.search();
    },
    channelImg(referenceSourceID) {
      switch (referenceSourceID) {
        case 3: return "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/shopee.png";
        case 4: return "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png";
        case 11: return "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/TikTok-Logo-1.png";
        case 906: return "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/linemyshop.png";
        default: return null;
      }
    },
    statusTextClass(statusID) {
      if (statusID == 90) return "green--text text--darken-1";
      if (statusID == 70 || statusID == 80) return "red--text";
      if (statusID == 10 || statusID == 20) return "blue-grey--text";
      return "orange--text text--darken-2";
    },
    logisticTextClass(statusID) {
      if (statusID == 30) return "green--text text--darken-1";
      if (statusID == 40 || statusID == 50) return "red--text";
      if (statusID == 10) return "blue-grey--text";
      if (statusID == 20) return "orange--text text--darken-2";
      return "";
    },
    formatDateShort(d) {
      if (!d) return "";
      const parts = String(d).split("-");
      if (parts.length !== 3) return d;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    formatDateTime(d) {
      if (!d) return "-";
      try {
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return d;
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
      } catch (e) {
        return d;
      }
    },
  },
};
</script>

<style scoped>
.refund-table >>> td,
.refund-table >>> th {
  text-align: center !important;
}
</style>